module.exports = __webpack_public_path__ + "img/bv-logo-zold.b7c0f61b.png";